export default [
    // {
    //     path: '/zh',
    //     redirect: '/', //重定向
    // },
    {
        path: '/',
        name: "首页",
        component: () => import('../views/home'),
    },
    {
        path: '/tour/:name',
        name: "全景图",
        component: () => import('../views/tour'),
    },
    // {
    //     path: '/tour',
    //     name: "全景图",
    //     component: () => import('../views/tour'),
    //     children: [
    //         {
    //             path: ':title',
    //             name: "全景图",
    //             component: () => import('../views/tour'),
    //         }
    //     ]
    // },
    {
        path: '/iframe/:type',
        name: "外链",
        component: () => import('../views/iframe'),
    },
]
